<template>
	<div class="item">
		<div>在租客户总数</div>
		<div class="value">
			<span style="font-size: 36px">85</span>
			<span style="font-size: 18px">个</span>
		</div>
		<div class="rate">占总住户92%</div>
		<div class="chart">
			<BaseChart :option="baseOption" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LeasedCustomerArea',
		props: {
			categories: {
				type: Array,
				default: () => [],
			},
		},
		computed: {
			baseOption() {
				return {
					color: ['#567CC8', '#425D97', '#6296FF', '#D9E6FF'],
					title: {
						text: '面积占比',
						top: '20%',
						left: '2%',
						textStyle: {
							fontSize: 16,
						},
					},
					grid: {
						left: '3%',
						right: '3%',
						bottom: '33%',
					},
					tooltip: {
						trigger: 'axis',
					},
					legend: { show: false },
					xAxis: {
						show: false,
						type: 'value',
					},
					yAxis: {
						show: false,
						type: 'category',
						data: ['统计'],
					},
					series: [
						{
							name: '0-100',
							type: 'bar',
							stack: 'total',
							itemStyle: {
								borderRadius: [4, 0, 0, 4],
							},
							label: {
								show: true,
								color: '#414755',
								fontWeight: 'bold',
								formatter: '0-100',
								offset: [-20, 23],
								position: 'insideBottomLeft',
							},
							emphasis: {
								focus: 'series',
							},
							data: [320],
						},
						{
							name: '100-200',
							type: 'bar',
							stack: 'total',
							label: {
								show: true,
								color: '#414755',
								fontWeight: 'bold',
								formatter: '100-200',
								offset: [-20, 23],
								position: 'insideBottomLeft',
							},
							emphasis: {
								focus: 'series',
							},
							data: [120],
						},
						{
							name: '200-300',
							type: 'bar',
							stack: 'total',
							label: {
								show: true,
								offset: [-20, 23],
								formatter: '200-300',
								color: '#414755',
								fontWeight: 'bold',
								position: 'insideBottomLeft',
							},
							emphasis: {
								focus: 'series',
							},
							data: [220],
						},

						{
							name: '300以上',
							type: 'bar',
							stack: 'total',
							showBackground: true,
							backgroundStyle: {
								color: '#E5EEFF',
							},
							itemStyle: {
								borderRadius: [0, 4, 4, 0],
							},
							label: {
								show: true,
								color: '#414755',
								fontWeight: 'bold',
								formatter: '300以上',
								offset: [-20, 23],
								position: 'insideBottomLeft',
							},
							emphasis: {
								focus: 'series',
							},
							data: [820],
						},
					],
				};
			},
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.item {
		width: 100%;
		height: 100%;
		color: #0b1c30;
	}

	.title,
	.rate {
		font-size: 11px;
		color: #0b1c30;
	}

	.value {
		margin: 4px 0;
		font-weight: bold;
	}

	.chart {
		margin-top: 10px;
		background: #fff;
		border-radius: 10px;
	}
</style>
